<mat-card class="card-password">
  <div class="flex justify-end mb-2">
    <mat-icon fontIcon="cancel" [mat-dialog-close]="true" class="btn-close" />
  </div>
  <div class="font-extrabold text-2xl text-center">
    Pronto! Uma nova senha foi <br />
    enviada para seu e-mail : )
  </div>
</mat-card>
